import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/JobDetailPage/Banner'
import Content from '../Component/JobDetailPage/Content'
import { useParams } from 'react-router-dom'
import { useAuth } from '../Context/ContextProvider'
import { useState } from 'react'
import { useEffect } from 'react'

function JobDetailPage() {
    const {id}=useParams()
    const {getJobDetails}=useAuth()
    const [jobDetail, setJobDetail] = useState(null)
    useEffect(()=>{
        const fetchJobDetail=async()=>{
            const resp=await getJobDetails(id)
            if(resp.success){
                setJobDetail(resp.data?.job)
            }
        }
        fetchJobDetail()
    },[id])
  return (
    <div>
        <NavBar/>
        <Content jobDetail={jobDetail}/>
        <Footer/>
    </div>
  )
}

export default JobDetailPage